var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtlLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#0CA7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.95 25L23.6 19.35L22.15 17.9L17.925 22.125L15.825 20.025L14.4 21.45L17.95 25ZM13 29C12.45 29 11.9792 28.8042 11.5875 28.4125C11.1958 28.0208 11 27.55 11 27V11C11 10.45 11.1958 9.97917 11.5875 9.5875C11.9792 9.19583 12.45 9 13 9H21L27 15V27C27 27.55 26.8042 28.0208 26.4125 28.4125C26.0208 28.8042 25.55 29 25 29H13ZM20 16V11H13V27H25V16H20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtlLetter);
export default __webpack_public_path__ + "static/media/etl-letter.acee4f9433b1100d2a6dfbcc7d98a73d.svg";
export { ForwardRef as ReactComponent };